import AjaxResponseActionHandler from "./AjaxResponseActionHandler";

class Paypal {
    paypalUrl = 'https://www.paypal.com/sdk/js?client-id={paypalAppClientId}&currency=EUR';

    constructor(paymentWrapperId, banktransferButtonId, paypalButtonContainerId) {
        this.paymentWrapperId = paymentWrapperId;
        this.banktransferButtonId = banktransferButtonId;
        this.containerId = paypalButtonContainerId;

        this.$paymentWrapper = $('#' + this.paymentWrapperId);
        this.$banktransferButton = $('#' + this.banktransferButtonId);
        this.$paypalContainer = $('#' + this.containerId);
        this.paypalAppClientId = this.$paypalContainer.data('paypalAppClientId');

        this.loadPaypal(this.initializePaypalButtons.bind(this));
        this.$banktransferButton.on('click', this.onBankTransferSubmit.bind(this));
    }

    submitAjax() {
        this.$paymentWrapper.find('#payment-overlay').removeClass('d-none');
    }

    loadPaypal(callback) {
        if (this.$paypalContainer.length === 0) {
            return;
        }
        let script = document.createElement('script');
        script.onload = callback;
        script.src = this.paypalUrl.replace('{paypalAppClientId}', this.paypalAppClientId);
        document.head.appendChild(script);
    }

    initializePaypalButtons() {
        paypal.Buttons({
            createOrder: this.createPaypalOrder.bind(this),
            onApprove: this.onPaypalApprove.bind(this)
        }).render('#' + this.containerId);
    }

    createPaypalOrder(data, actions) {
        let amount = this.$paypalContainer.data('amount');
        let description = this.$paypalContainer.data('description');
        return actions.order.create({
            purchase_units: [{
                description: description,
                amount: {
                    value: amount
                }
            }]
        });
    }

    onPaypalApprove(data, actions) {
        this.submitAjax();
        let approveUrl = decodeURIComponent(this.$paypalContainer.data('approveUrl'));
        // approveUrl = approveUrl.replace('###orderId###', data.orderID);
        // let postData = AjaxHelper.queryString(approveUrl);
        // approveUrl = AjaxHelper.baseUrl(approveUrl);
        let postData = {
            tx_conmanager_conventions: {
                orderId: data.orderID,
                paymentMethod: 'PAYPAL'
            }
        };
        return actions.order.capture().then(function(details) {
            return $.ajax({
                url: approveUrl,
                type: "POST",
                data: postData,
                dataType: 'json'
            }).then(AjaxResponseActionHandler.ajaxCallback);
        }.bind(this));
    }

    onBankTransferSubmit(event) {
        event.preventDefault();
        this.submitAjax();

        let approveUrl = decodeURIComponent(this.$banktransferButton.data('action'));
        let postData = {
            tx_conmanager_conventions: {
                paymentMethod: 'BANK_TRANSFER'
            }
        };
        return $.ajax({
            url: approveUrl,
            type: "POST",
            data: postData,
            dataType: 'json'
        }).then(AjaxResponseActionHandler.ajaxCallback);
    }
}

export default Paypal;